// eslint-disable-next-line
import { numberToWords } from '@persian-tools/persian-tools';

/**
 * convert number to persian word
 * @param {string|number}v
 * @returns {string}
 */
const balanceHint = (v) => {
    if(v<=9005000000000000){
        return numberToWords(v);
    }else return ''
};
export default balanceHint;